/* NT 91 – Club NT 91 : couronnes estimées sur le formulaire de devis et les fiches prestations, parrainage à partager (22/10/2026).
   Règles (page /pages/club-nt91, validées par le gérant le 21/10/2026) : 1 couronne par euro de nettoyage payé après remise
   (hors enlèvement, express, VIP et Pass), x2 avec le Pass NT 91 Privilège, 50 couronnes de bienvenue à la première commande,
   100 couronnes au parrain. Le statut (Argent, Or) et le solde ne sont pas connus ici : les estimations affichées sont des minimums.
   Chargé avant nt.js, qui envoie l’événement « nt:estimate » à chaque calcul du devis. */
(function () {
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var CR = '<svg viewBox="0 0 22 16" aria-hidden="true"><path d="M3.5 12 2 4l5 4 4-6.5L15 8l5-4-1.5 8z"/><path d="M3 13.6h16v1.8H3z"/></svg>';
  var PAGE = '/pages/club-nt91';
  var RW = [[100, 'le parfum de finition offert'], [300, 'le traitement anti-mites offert sur un article'], [500, 'l’enlèvement et la livraison offerts'], [800, 'un bon de 40 €'], [1500, 'un bon de 80 €']];
  function fmt(n) { return Math.round(n).toLocaleString('fr-FR'); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function count(el, a, b, ms) {
    if (el._r) cancelAnimationFrame(el._r);
    if (RM || a === b) { el.textContent = fmt(b); return; }
    var t0 = null;
    function st(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(a + (b - a) * e); if (p < 1) el._r = requestAnimationFrame(st); }
    el._r = requestAnimationFrame(st);
  }
  function pop(el) { if (RM) return; el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop'); }
  function fly(host, x, y, n) {
    if (RM) return;
    for (var i = 0; i < n; i++) {
      var s = document.createElement('span'), a = Math.PI * (0.2 + 0.6 * Math.random()), d = 40 + Math.random() * 50;
      s.className = 'cl-fly'; s.innerHTML = CR; s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--x', Math.round(Math.cos(a) * d * (Math.random() < 0.5 ? -1 : 1)) + 'px');
      s.style.setProperty('--y', Math.round(-Math.sin(a) * d - 14) + 'px');
      s.style.setProperty('--r', Math.round(Math.random() * 50 - 25) + 'deg');
      s.style.animationDelay = (i * 45) + 'ms';
      s.addEventListener('animationend', function () { if (this.parentNode) this.parentNode.removeChild(this); });
      host.appendChild(s);
    }
  }
  /* « De quoi obtenir… » et « plus que N couronnes pour… » à partir des couronnes de cette seule commande */
  function next(c) {
    var best = null, nx = null;
    for (var i = 0; i < RW.length; i++) { if (c >= RW[i][0]) best = RW[i]; else if (!nx) nx = RW[i]; }
    var t = [];
    if (best) t.push('de quoi obtenir ' + best[1] + ' à votre prochaine commande');
    if (nx) t.push((best ? 'plus que ' : 'encore ') + fmt(nx[0] - c) + ' couronnes pour ' + nx[1]);
    return t.join(' ; ');
  }

  /* Formulaire de devis : pastille sur la barre d’estimation et ligne dans le récapitulatif */
  var est = document.getElementById('ntEst');
  if (est) {
    var pill = document.createElement('span'); pill.className = 'est-cl'; pill.hidden = true;
    pill.innerHTML = CR + '<span>+ <b>0</b> couronnes</span>';
    est.insertBefore(pill, est.firstChild);
    var pb = pill.querySelector('b'), tot = document.getElementById('ntRecapT'), line = null, last = 0;
    if (tot && tot.parentNode && tot.parentNode.parentNode) {
      line = document.createElement('p'); line.className = 'rc-club'; line.hidden = true;
      tot.parentNode.parentNode.insertBefore(line, tot.parentNode.nextSibling);
    }
    document.addEventListener('nt:estimate', function (e) {
      var d = e.detail || {}, net = Math.max(0, (+d.base || 0) - (+d.rem || 0)) / 100, c = Math.floor(net * (d.pass ? 2 : 1) + 1e-6);
      if (c <= 0) { pill.hidden = true; if (line) line.hidden = true; last = 0; return; }
      pill.hidden = false;
      count(pb, last, c, 600);
      if (c > last) { pop(pill); fly(est, 26, -6, Math.min(8, 3 + Math.floor((c - last) / 60))); }
      last = c;
      if (line) {
        var tc = c + (d.bv ? 50 : 0);
        line.hidden = false;
        line.innerHTML = CR + '<span>Club NT 91 : au moins <b>' + fmt(c) + ' couronnes</b> créditées au règlement de la facture' +
          (d.pass ? ' (doublées avec le Pass)' : '') + (d.bv ? ', plus 50 couronnes de bienvenue' : '') + '.' +
          '<span class="cl-next">Avec cette seule commande : ' + next(tc) + '. <a href="' + PAGE + '" target="_blank" rel="noopener">Découvrir le Club (nouvel onglet)</a></span></span>';
      }
    });
  }

  /* Fiches prestations : couronnes du prix estimé */
  var pt = document.getElementById('ntProdTot'), g = document.getElementById('ntClubGain');
  if (pt && g) {
    var lp = 0, gb = null, gn = null;
    var upd = function () {
      var v = parseFloat((pt.textContent || '').replace(/[^\d,]/g, '').replace(',', '.')) || 0, c = Math.floor(v + 1e-6);
      if (c <= 0) { g.hidden = true; return; }
      if (!gb) {
        g.innerHTML = CR + '<span>Club NT 91 : au moins <b>0</b> couronnes pour cette prestation. <span class="cl-next"></span> <a href="' + PAGE + '">Découvrir le Club</a></span>';
        gb = g.querySelector('b'); gn = g.querySelector('.cl-next');
      }
      g.hidden = false;
      count(gb, lp, c, 500);
      gn.textContent = next(c).replace(/^./, function (m) { return m.toUpperCase(); }) + '.';
      if (lp && c > lp) pop(g);
      lp = c;
    };
    new MutationObserver(upd).observe(pt, { childList: true, characterData: true, subtree: true });
    upd();
  }

  /* Parrainage à partager : après l’envoi d’une demande de devis et sur tout bloc [data-cl-share] */
  function share(host, titre) {
    var box = document.createElement('div'); box.className = 'cl-share';
    box.innerHTML = '<h3>' + esc(titre) + '</h3>' +
      '<p>Recommandez NT 91 à un proche : quand sa première commande est réglée, vous recevez 100 couronnes. Sa première commande lui rapporte aussi 50 couronnes de bienvenue.</p>' +
      '<label for="clShareNom">Votre prénom et votre nom, pour qu’il les indique dans sa demande</label>' +
      '<input type="text" id="clShareNom" autocomplete="name">' +
      '<div class="acts"><a class="btn btn-or" data-cl="wa" href="#" rel="noopener">Envoyer sur WhatsApp</a><a class="btn btn-w" data-cl="sms" href="#">Envoyer par SMS</a><button type="button" class="btn btn-w" data-cl="copy">Copier le message</button></div>' +
      '<span class="cl-ok" aria-live="polite"></span>';
    host.appendChild(box);
    var inp = box.querySelector('input'), ok = box.querySelector('.cl-ok');
    function msg() {
      var n = (inp.value || '').trim();
      return 'Je te recommande NT 91 pour le nettoyage de tes tapis, canapés, matelas, couettes et cuirs, avec enlèvement et livraison à domicile.\n' +
        'Demande ton devis : https://nettoyagetapis91.com/pages/devis\n' +
        (n ? 'Indique mon nom, ' + n + ', dans « Un proche vous a recommandé NT 91 ? ».\n' : 'Indique mon nom dans « Un proche vous a recommandé NT 91 ? ».\n') +
        'Ta première commande t’offre 50 couronnes de bienvenue au Club NT 91 : https://nettoyagetapis91.com/pages/club-nt91';
    }
    function sync() {
      var m = encodeURIComponent(msg());
      box.querySelector('[data-cl="wa"]').href = 'https://wa.me/?text=' + m;
      box.querySelector('[data-cl="sms"]').href = 'sms:?&body=' + m;
    }
    inp.addEventListener('input', sync); sync();
    box.querySelector('[data-cl="copy"]').addEventListener('click', function () {
      var t = msg();
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(function () { ok.textContent = 'Message copié : collez-le dans votre messagerie.'; }, function () { ok.textContent = t; });
      else ok.textContent = t;
    });
  }
  var okBox = document.querySelector('#ntDevis .ok');
  if (okBox) share(okBox, 'En attendant votre devis : parrainez un proche, gagnez 100 couronnes');
  var hosts = document.querySelectorAll('[data-cl-share]');
  for (var h = 0; h < hosts.length; h++) share(hosts[h], hosts[h].getAttribute('data-cl-share') || 'Parrainez un proche, gagnez 100 couronnes');

  /* Encart d’inscription au Club (accueil) : visiteur déjà inscrit, ou secours si le message de réussite n’est pas affiché */
  var hj = document.getElementById('rejoindre');
  if (hj && !hj.querySelector('.hcl-ok')) {
    var hst = '', hcd = '';
    try { hst = localStorage.getItem('nt_bv') || ''; hcd = localStorage.getItem('nt_bv_code') || ''; } catch (e) {}
    var posted = location.hash === '#ntClubJoin' && /[?&]customer_posted=true/.test(location.search) && !hj.querySelector('.hcl-err');
    if (posted || hst === 'inscrit') {
      var code = hcd || hj.getAttribute('data-code') || 'BIENVENUE10', pct = hj.getAttribute('data-pct') || '10', fm = hj.querySelector('form');
      if (fm) {
        fm.innerHTML = '<div class="hcl-ok" role="status"><p class="hcl-k">Club NT 91</p><h2 class="hcl-t">Bienvenue au Club</h2><p>Votre code de bienvenue : <b class="hcl-code"></b>, soit -' + esc(pct) + String.fromCharCode(160) + '% sur votre première commande. Vos 50 couronnes de bienvenue sont créditées dès le règlement de votre première commande, puis chaque euro de nettoyage vous rapporte une couronne.</p><a class="btn btn-or" href="/pages/devis?code=' + encodeURIComponent(code) + '">Demander mon devis</a></div>';
        fm.querySelector('.hcl-code').textContent = code;
      }
    }
  }
})();
